import { useEffect, useState } from 'react';
import FaceLandmarkCanvas from './FaceLandmarkCanvas';

import { IConfig } from '@/interface/game';
import { ICanvasElement } from '@/interface/canvas';
import { loadScript } from '@/util/script';
import { AframeListener } from '../js/aframeListener';
import { renderARElements } from '@/helper/ar';
import FaceTryonSceneInit from './FaceTryonSceneInit';
import GameTimer from '../GameTimer';

const scripts = [
  {
    uri: 'https://aframe.io/releases/1.7.1/aframe.min.js',
  },

  {
    uri: 'https://cdn.jsdelivr.net/gh/c-frame/aframe-extras@7.4.0/dist/aframe-extras.min.js',
  },
];

type FaceTryonContentProps = {
  config?: IConfig;
};
const FaceTryonContent = ({ config }: FaceTryonContentProps) => {
  const [maskConfig, setMaskConfig] = useState<ICanvasElement | undefined>(
    undefined
  );
  const [isAframeListenerLoaded, setIsAframeListenerLoaded] = useState(false);
  const [isScriptLoaded, setScriptLoaded] = useState(false);

  const renderElements = () => {
    const elements = config?.elements || [];

    renderARElements(elements, undefined);
  };
  const onLoadScripts = async () => {
    if (isScriptLoaded) return;
    for (const item of scripts) {
      await loadScript(item.uri);
    }
    setScriptLoaded(true);
  };
  useEffect(() => {
    onLoadScripts();
  }, []);
  useEffect(() => {
    if (!isScriptLoaded) return;
    if (isAframeListenerLoaded) {
      const scene: any = document.querySelector('a-scene');
      if (scene && scene.hasLoaded) {
        renderElements();
      } else if (scene) {
        scene.addEventListener('loaded', renderElements);
      }
    }
    if (!isAframeListenerLoaded) {
      new AframeListener();
      setIsAframeListenerLoaded(true);
    }
  }, [isAframeListenerLoaded, isScriptLoaded]);
  useEffect(() => {
    if (config) {
      const elements = config.elements || [];
      const mask = elements.find(ele => ele.type === 'FACE_TEXTURE');
      if (mask) setMaskConfig(mask);
    }
  }, [config]);
  if (!isScriptLoaded) return <div>Loading AR experience...</div>;
  return (
    <div className="w-full min-h-screen h-full flex">
      {maskConfig && <FaceLandmarkCanvas maskConfig={maskConfig} />}
      <FaceTryonSceneInit />
      <GameTimer timer={config?.timer} />
    </div>
  );
};

export default FaceTryonContent;
